import { Box, StyleProps, Text } from "@chakra-ui/react";
import React from "react";
import { useTranslation } from "react-i18next";

export interface EmptyStateProps extends StyleProps {
  title?: string;
  description?: string;
  children?: React.ReactNode;
}

const EmptyState: React.FC<EmptyStateProps> = ({
  children,
  description,
  title,
  ...props
}) => {
  const { t } = useTranslation(["common"]);
  return (
    <Box
      py="24px"
      my="24px"
      textAlign="center"
      className="empty-state"
      {...props}
    >
      <Text fontSize="16px" fontWeight="medium">
        {title || t("common:empty.title")}
      </Text>
      {description && (
        <Text fontSize="14px" textColor="gray.600" pt={2}>
          {description}
        </Text>
      )}
      {children && <Box pt={6}>{children}</Box>}
    </Box>
  );
};
export default EmptyState;
